import React from "react";
import ProductDetailHeadingItemNumber from "./ProductDetailHeadingItemNumber";
import QuestionAndAnswerLink from "./QuestionAndAnswerLink";
import ReviewsLink from "./ReviewsLink";

interface ProductDetailHeadingProps {
  itemNumber: string;
  descriptionHtml: string;
  rating: number;
  numberOfReviews: number;
  showVendorItemNumber: boolean;
  actualVendorItemNumber: string;
  isEverLiving: boolean;
  isOutlet?: boolean;
  numberOfAnswers?: number;
  isGroupMaster?: boolean;
  minimalPageVersion?: boolean;
}
const ProductDetailHeading = ({
  itemNumber,
  descriptionHtml,
  rating,
  numberOfReviews,
  showVendorItemNumber,
  actualVendorItemNumber,
  isEverLiving,
  isOutlet = false,
  numberOfAnswers = 0,
  isGroupMaster = false,
  minimalPageVersion = false,
}: ProductDetailHeadingProps) => {
  return (
    <>
      <h1
        className="page-header order-none skip-to-main-target"
        data-gotowebstore={itemNumber}
        id="page-header-description"
        data-testid="product-detail-heading"
        dangerouslySetInnerHTML={{
          __html: descriptionHtml,
        }}
      />
      <div className="product-subhead flex items-center order-none flex-col-reverse lt:flex-row !items-start lt:!items-center gap-1 lt:gap-0">
        <div className="flex lt:block">
          {!!numberOfReviews || !isEverLiving ? (
            <ReviewsLink
              itemNumber={itemNumber}
              minimalPageVersion={minimalPageVersion}
              numberOfReviews={numberOfReviews}
              rating={rating}
            />
          ) : null}
          {!isEverLiving && !isOutlet && !isGroupMaster ? (
            <QuestionAndAnswerLink numberOfAnswers={numberOfAnswers} />
          ) : null}
        </div>
        <ProductDetailHeadingItemNumber
          itemNumber={itemNumber}
          showVendorItemNumber={showVendorItemNumber}
          actualVendorItemNumber={actualVendorItemNumber}
        />
      </div>
    </>
  );
};

export default ProductDetailHeading;
